import React, { useState, useEffect, memo } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect, useHistory } from 'react-router-dom';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { useConfiguration } from '../../context/configurationContext';
import { injectIntl } from '../../util/reactIntl';
import css from './NPOEnrollPage.module.css';
import { NPOEnrollForm } from './components/NPOEnrollForm';
import { signup, getParentInfo } from './NPOEnroll.duck';
import { Page } from '../../components';
import logo from '../../assets/jaikan-logo.png';

const EnhancedNPOEnrollPage = (props) => {
  const {
    intl, scrollingDisabled, onManageDisableScrolling, location, isAuthenticated,
    tosFetchInProgress, tosFetchError, tosAssetsData
  } = props;
  const history = useHistory();
  const parentId = new URLSearchParams(location.search).get('parentId');
  const config = useConfiguration();
  const [parentInfo, setParentInfo] = useState();
  const [loading, setLoading] = useState(false);
  const [existEmail, setExistEmail] = useState(false);
  const logoImg = (
    <img src={logo} alt={config.marketplaceName} />
  );

  const onSubmit = async (values) => {
    if (loading) {
      return;
    }

    setLoading(true);
    setExistEmail(false);

    const {
      fname, lname, associationName, email, password, address, city, zip,
      schoolName, newsletterSubscription, secondAddress,
    } = values;
    const params = {
      firstName: fname.trim(),
      lastName: lname.trim(),
      email,
      password,
      publicData: {
        userType: 'npoDraft',
        associationName: associationName.trim(),
        address: address.trim(),
        zip,
        city: city.trim(),
        'provider-tos': values['provider-tos'],
        'terms': values['terms']
      },
    };

    if (schoolName) {
      params.publicData.schoolName = schoolName;
    }

    if (newsletterSubscription) {
      params.publicData.newsletterSubscription = newsletterSubscription;
    }

    if (secondAddress) {
      params.publicData.secondAddress = secondAddress;
    }

    if (parentInfo) {
      params.publicData.parentId = parentInfo.id;
      params.publicData.parentAssociationName = parentInfo.associationName;
    }

    try {
      await props.dispatch(signup(params));
      history.push('/npo-candidate');
    } catch (e) {
      if (e?.status === 409) {
        setExistEmail(true);
        setTimeout(() => {
          document.getElementById('npodraft').scrollTo(0, 1000000)
        }, 100);
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    if (parentId) {
      props.dispatch(getParentInfo(parentId)).then((res) => {
        if (res) {
          const { data: { data } } = res;

          if (data?.attributes?.profile?.publicData?.associationName) {
            setParentInfo({
              associationName: data.attributes.profile.publicData.associationName,
              id: parentId
            });
          }
        }
      });
    }
  }, []);

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
    <Page title="S'inscrire" scrollingDisabled={scrollingDisabled}>
      <div className={css.header}>
        {logoImg}
        <span className={css.titlePage}>Créer un compte Jaïkan</span>
      </div>
      <div className={css.wrapper}>
        <div className={css.wrapperFrame} id="npodraft">
          <div className={css.formBox}>
            <NPOEnrollForm
              onSubmit={onSubmit}
              intl={intl}
              tosFetchInProgress={tosFetchInProgress}
              tosFetchError={tosFetchError}
              tosAssetsData={tosAssetsData}
              onManageDisableScrolling={onManageDisableScrolling}
              parentInfo={parentInfo}
              loading={loading}
              isAuthenticated={isAuthenticated}
            />
            {
              existEmail? (
                <p style={{ color: 'red' }}>
                  Un compte avec cette adresse e-mail existe déjà. Essayez plutôt de vous connecter.
                </p>
              ) : <></>
            }
          </div>
          <div style={{ height: '30px', width: '100%' }}></div>
        </div>
      </div>
    </Page>
  );
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const {
    pageAssetsData: privacyAssetsData,
    inProgress: privacyFetchInProgress,
    error: privacyFetchError,
  } = state.hostedAssets || {};
  const { pageAssetsData: tosAssetsData, inProgress: tosFetchInProgress, error: tosFetchError } =
    state.hostedAssets || {};

  return {
    user: state.user.currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    isAuthenticated,
    privacyAssetsData,
    privacyFetchInProgress,
    privacyFetchError,
    tosAssetsData,
    tosFetchInProgress,
    tosFetchError,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  onManageDisableScrolling: (componentId, disableScrolling) => dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const NPOEnrollPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(memo(EnhancedNPOEnrollPage));

NPOEnrollPage.displayName = 'NPOEnrollPage';

export default NPOEnrollPage;
